import { Flex, SimpleGrid } from "@chakra-ui/react";
import ButtonComp from "components/Button";
import { Header } from "components/Header";
import InputComp from "components/InputComp";
import Layout from "components/Layout";
import { toaster } from "components/ui/toaster";
import useCheckMobileScreen from "hooks/useCheckMobileScreen";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "services/api";

// const headers = ["Limit"];

// const items = [
//   {
//     id: 1,
//     Duration: "1 Months",
//   },
// ];

function ClaimLimitsManage() {
  const [isLoading, setIsLoading] = useState(false);
  const [purchaselimitamount, setPurchaselimitamount] = useState();
  const ismobile = useCheckMobileScreen();
  const navigate = useNavigate();
  const location = useLocation();

  const action = location.state?.action;
  const itemData = location.state?.data;

  const onSave = async () => {
    setIsLoading(true);
    const res = await api.updatePurchaselimit({
      purchaselimitid: itemData?.purchaselimitid,
      purchaselimitamount,
    });

    setIsLoading(false);
    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: res?.status === 200 ? "success" : "error",
    });

    if (res?.status === 200) {
      navigate("/claimlimits", {
        state: {},
      });
    }
  };

  const onNew = async () => {
    setIsLoading(true);
    const res = await api.addPurchaselimit({
      purchaselimitamount,
    });

    setIsLoading(false);
    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: res?.status === 200 ? "success" : "error",
    });

    if (res?.status === 200) {
      // getList();
      navigate("/claimlimits", {
        state: {},
      });
    }
  };

  // const onSelectItm = (data) => {
  //   console.log("selected item d id =", data?.item?.data?.purchaselimitamount);

  //   setSelectedItem(data);
  //   setPurchaselimitamount(data?.item?.data?.purchaselimitamount || 0);
  //   // setDurationvalue(data?.item?.data?.durationvalue);
  // };

  useEffect(() => {
    const cb = async () => {
      if (itemData?.purchaselimitamount) {
        setPurchaselimitamount(itemData?.purchaselimitamount);
      }
    };
    cb();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header
        label={"Claim Limits"}
        // ${
        // action === "duration-edit"
        //   ? `${itemData?.policynumber ? " - " + itemData?.policynumber : ""}`
        //   : ""
        // }`}
        isLoading={isLoading}
      />
      <Layout>
        <Flex
          flex={1}
          // maxW={"26rem"}
          direction={"column"}
          overflow={"scroll"}
          gap={"0.6rem"}
          justifyContent={"space-between"}
        >
          <SimpleGrid columns={ismobile ? 1 : 1} columnGap="1rem" rowGap="1rem">
            <InputComp
              label={"Amount"}
              type={"number"}
              placeholder={"Amount"}
              value={purchaselimitamount}
              onChange={setPurchaselimitamount}
            />
          </SimpleGrid>
        </Flex>
      </Layout>
      <Flex flexFlow={"wrap"} mt={"1rem"} gap={"1rem"} alignSelf={"end"}>
        {action === "claimlimits-edit" ? (
          <ButtonComp
            label={"Save"}
            onClick={onSave}
            keyname={"save"}
            disabled={isLoading}
          />
        ) : (
          <ButtonComp
            label={"Add"}
            onClick={onNew}
            keyname={"add"}
            disabled={isLoading}
          />
        )}
      </Flex>
    </Flex>
  );
}

export default ClaimLimitsManage;
